var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GenericWrapperChart',{attrs:{"config":_vm.config},scopedSlots:_vm._u([{key:"afterChart",fn:function(){return [(_vm.$store.state.ui.channel === 'Todas')?_c('span',[_vm._v(_vm._s(_vm.message))]):_vm._e()]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }